"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fs_1 = __importDefault(require("fs"));
var path_1 = __importDefault(require("path"));
var seamless_immutable_1 = __importDefault(require("seamless-immutable"));
var DEFAULT_LOCALE = 'en-US';
function encodeLocale(locale) {
    if (!locale)
        return null;
    return locale.replace(/-/g, '_');
}
var DEFAULT_COOKIE = 'EPIC_LOCALE';
var messageFileFormat = /messages.*_([a-zA-Z0-9-]+)\.json$/;
var getDirectoryMessages = function (directory, files) {
    var folderMessages = {};
    for (var i = 0; i < files.length; i++) {
        var file = files[i];
        var fileMatch = messageFileFormat.exec(file);
        if (fileMatch) {
            var locale = fileMatch[1];
            folderMessages[locale] = JSON.parse(fs_1.default.readFileSync(path_1.default.join(directory, file), 'utf8'));
        }
    }
    return folderMessages;
};
var addDirectoryToConfig = function (directory) {
    return new Promise(function (resolve, reject) {
        fs_1.default.readdir(directory, function (err, files) {
            var localeMessages = getDirectoryMessages(directory, files);
            resolve(localeMessages);
        });
    });
};
var addDirectoriesToConfig = function (input) {
    var directories = Array.isArray(input) ? input : [input];
    return directories.map(function (directory) { return addDirectoryToConfig(directory); });
};
var applyDefaultLocaleMessagesToOtherLocales = function (localization) {
    var _a = DEFAULT_LOCALE, defaultLocaleMessages = localization[_a], otherMessages = __rest(localization, [typeof _a === "symbol" ? _a : _a + ""]);
    Object.keys(otherMessages).forEach(function (locale) {
        localization[locale] = __assign(__assign({}, defaultLocaleMessages), localization[locale]);
    });
};
var mergeMessageBundleResults = function (messageBundles) {
    if (!messageBundles)
        return {};
    var localization = {};
    for (var i = messageBundles.length - 1; i >= 0; i--) {
        var bundle = messageBundles[i];
        for (var locale in bundle) {
            if (!bundle.hasOwnProperty(locale))
                continue;
            if (!localization.hasOwnProperty(locale)) {
                localization[locale] = bundle[locale];
            }
            else {
                Object.assign(localization[locale], bundle[locale]);
            }
        }
    }
    return localization;
};
function MessageLoader(directories, localeConfig) {
    return __awaiter(this, void 0, void 0, function () {
        var config;
        return __generator(this, function (_a) {
            if (!localeConfig || !localeConfig.locales) {
                console.error('MessageLoader failed to load locales! localeConfig object parameter with supported "locales" field is required but is invalid!');
                throw new Error('MessageLoader failed to load localization data. Invalid localeConfig');
            }
            config = {
                localeCookie: localeConfig.localeCookie || DEFAULT_COOKIE,
                DEFAULT_LOCALE: localeConfig.DEFAULT_LOCALE || DEFAULT_LOCALE,
                defaultLocale: localeConfig.DEFAULT_LOCALE || DEFAULT_LOCALE,
                overrideLocales: localeConfig.overrideLocales || {},
                allLocales: localeConfig.overrideLocales ? Object.keys(localeConfig.overrideLocales) : [],
                supportedLocales: []
            };
            localeConfig.locales.forEach(function (locale) {
                var encodedLocale = encodeLocale(locale);
                if (!config.allLocales.includes(locale)) {
                    config.allLocales.push(locale);
                    config.supportedLocales.push({
                        name: "epic.header.locale.name." + encodedLocale,
                        lang: locale
                    });
                }
            });
            return [2, Promise.all(addDirectoriesToConfig(directories)).then(function (results) {
                    var localization = mergeMessageBundleResults(results);
                    if (Object.keys(localization).length > 0) {
                        applyDefaultLocaleMessagesToOtherLocales(localization);
                        config.localization = { messages: seamless_immutable_1.default(localization) };
                    }
                    return config;
                })];
        });
    });
}
exports.MessageLoader = MessageLoader;
//# sourceMappingURL=data:application/json;base64,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